import React, { useEffect } from "react";
import {
  contactInformationFormReducer,
  mapStateToProps,
  mapDispatchToProps,
} from "./ContactInformationForm.store";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { connect } from "react-redux";
import { sendNotification } from "../../ToastManager/ToastManager";
import { ToastType } from "../../ToastManager/constants";
import ContactInformationForm from "../../library/ContactInformationForm/ContactInformationForm";
import LoadingSpinner from "../../ui-library/LoadingSpinner/LoadingSpinner";
import { getCurrentLocale, getLanguageName } from "../../../i18n/helpers";
import { useTranslation } from "react-i18next";

export const SmartContactInformationForm = (props) => {
  const {
    onClose,
    username,
    email,
    phoneCountry,
    phone,
    yearBirth,
    notifications,
    sendContactInformation,
    studyId,
    fetchParticipant,
    participantId,
    shouldFetchParticipant,
    resetState,
    participantLanguage,
    caregiverParticipantId,
    timezone,
    timeFormat,
    fetchTimezonesList,
    timezonesList,
  } = props;

  const { t } = useTranslation();

  const handleSubmit = (formData) => {
    sendContactInformation(formData)
      .then((message) => {
        sendNotification(message, ToastType.SUCCESS);
        clearFormAndClose();
      })
      .catch((error) => {
        sendNotification(error, ToastType.ERROR);
      });
  };

  useEffect(() => {
    if (!timezonesList) {
      let locale = getCurrentLocale();
      if (locale.includes("-")) {
        locale = locale.split("-")[0];
      }
      fetchTimezonesList(locale.toLowerCase());
    }
  }, [timezonesList, fetchTimezonesList]);

  useEffect(() => {
    return () => resetState();
  }, [resetState]);

  useEffect(() => {
    if (shouldFetchParticipant) {
      fetchParticipant(participantId);
    }
  }, [participantId, fetchParticipant, shouldFetchParticipant]);

  const clearFormAndClose = () => {
    resetState();
    onClose();
  };

  return (
    <>
      {username ? (
        <ContactInformationForm
          onSubmit={handleSubmit}
          onClose={clearFormAndClose}
          username={username}
          email={email}
          phoneCountry={phoneCountry}
          phone={phone}
          yearBirth={yearBirth}
          notifications={notifications}
          studyId={studyId}
          language={t(getLanguageName(participantLanguage))}
          caregiverParticipantId={caregiverParticipantId}
          timezone={timezone}
          timeFormat={timeFormat}
          timezonesList={timezonesList}
        />
      ) : (
        <LoadingSpinner />
      )}
    </>
  );
};

export default dynamic(
  "contactInformationFormReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state) => ({
      loginReducer: state.loginReducer,
      participantLanguage: state.participantLanguage,
    }),
  }),
  attachReducer(contactInformationFormReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SmartContactInformationForm));
